'use client';

import { useEffect } from 'react';
import { Module } from '@/components/utilities/content-modules/module-list/module-list';
import ModuleList, {
  ModuleListProps,
} from '@/components/utilities/content-modules/module-list/module-list';
import { trackViewEvent } from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';
import { usePageDetailsContext } from '@/libraries/contexts/page-details-context/page-details-context';

export interface ForbiddenProps extends ModuleListProps {
  /** The modal to open */
  modalType: Content.Components['ModalType'] | null;
  /** An array of the modules to show */
  modules: Module[];
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const Forbidden = ({
  modalType,
  modules,
  personalizationData,
  trackingData,
}: ForbiddenProps) => {
  const { setActiveModal } = usePageDetailsContext();

  useEffect(() => {
    if (!modalType) return;

    setActiveModal(modalType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <ModuleList modules={modules} />
    </div>
  );
};

Forbidden.displayName = 'Forbidden';

export default Forbidden;
